import React, { PropsWithChildren } from "react"
import { useSiteMetadata } from "../hooks/useSiteMetadata"
import { ImageProps, getFullShotUrl } from "./shot"

type SEOProps = PropsWithChildren<{
    title: string
    canonicalUrl: string
    image?: ImageProps
    description?: string
}>

export const SEO = ({ title, description, canonicalUrl, image, children }: SEOProps) => {
  const { title: defaultTitle, siteUrl } = useSiteMetadata()
  const imageUrl = image && getFullShotUrl(image, 'w400')
  const seo = {
    title: title || defaultTitle,
    description: description,
    image: imageUrl,
    canonicalUrl: `${canonicalUrl}`
    //url: `${siteUrl}${pathname || ``}`,    
  }

  return (
    <>
      <title>{seo.title}</title>
      {seo.description && <>
        <meta name="description" content={seo.description} />
        <meta property="og:description" content={seo.description} />      
      </>}
      {
        image && seo.image &&  <>
        <meta property="og:image" content={seo.image} />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content={`${400 * image.height/image.width }`} />
      </>}

      <meta property="og:title" content={seo.title} />   
      <meta property="og:url" content={seo.canonicalUrl} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:site_name" content="Wie was de Mol?" />

      <link rel="canonical" href={seo.canonicalUrl} />
      
      {/*<link rel="icon" href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='0.9em' font-size='90'>👤</text></svg>" />*/}
      {children}
    </>
  )
}